import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=6be4d2bc&scoped=true"
import script from "./TeamPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TeamPage.vue?vue&type=style&index=0&id=6be4d2bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4d2bc",
  null
  
)

export default component.exports